import { render, staticRenderFns } from "./fccExportacao.vue?vue&type=template&id=380c3768"
import script from "./fccExportacao.vue?vue&type=script&lang=js"
export * from "./fccExportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports